export class MandatoryForCoverages {
    coverageIds: number[];
    languageId: number;
    productTemplateId: number;
}